document.addEventListener("DOMContentLoaded", () => {
  const titles = document.querySelectorAll(".footer__title");

  titles.forEach(title => {
    title.addEventListener("click", event => {
      const clickedTitle = event.currentTarget;
      const parent = clickedTitle.closest(".hidden-desktop");
      if (!parent) return;

      const currentList = parent.querySelector("ul");
      const chevronUp = clickedTitle.querySelector(".chevron-up");
      const chevronDown = clickedTitle.querySelector(".chevron-down");
      if (!currentList || !chevronUp || !chevronDown) return;

      // Fermer tous les autres menus
      document.querySelectorAll(".hidden-desktop").forEach(section => {
        if (section !== parent) {
          const list = section.querySelector("ul");
          const up = section.querySelector(".chevron-up");
          const down = section.querySelector(".chevron-down");
          if (list && up && down) {
            list.style.display = "none";
            up.style.display = "none";
            down.style.display = "inline";
          }
        }
      });

      // Basculer l’état du menu cliqué
      const isVisible = currentList.style.display === "block";
      currentList.style.display = isVisible ? "none" : "block";
      chevronUp.style.display = isVisible ? "none" : "inline";
      chevronDown.style.display = isVisible ? "inline" : "none";
    });
  });

  // $('.header__link:eq(0)').css({
  //   'padding-right': '20%',
  //   'margin-bottom': '-13%'
  // });

  // $('.wrapper-icon-top-bar:eq(0)').css('display', 'none');
  // $('.wrapper-icon-top-bar:eq(2)').css('display', 'none');
  // $('.header-cart:eq(0)').css("padding-left", "5%");

  // $('.wrapper-icon-top-bar:eq(6)').css('display', 'none');
  // $('.wrapper-icon-top-bar:eq(4)').css('display', 'none');
  // $('.header__link:eq(16)').css('padding-top', 0);
  console.log("==========  padding-top : ", $('.header__link:eq(16)').css('padding-top'));
});